import React from 'react';
import reducer from './reducers';
import { createStore } from "redux";
import { Provider } from "react-redux";
import { render } from 'react-dom';
import App from './App';

//import registerServiceWorker from './registerServiceWorker';

import 'normalize.css';
import 'font-awesome/css/font-awesome.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles/css/index.css';

const store = createStore(reducer);

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js